import { render, staticRenderFns } from "./firstRegister.vue?vue&type=template&id=62f78672&scoped=true"
import script from "./firstRegister.vue?vue&type=script&lang=js"
export * from "./firstRegister.vue?vue&type=script&lang=js"
import style0 from "./firstRegister.vue?vue&type=style&index=0&id=62f78672&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f78672",
  null
  
)

export default component.exports